<template>

<div class="page">
  <DemoMast :imgName="meta.imgName">
    <template v-slot:title>Leak Lens</template>
    <template v-slot:copy>배관설비에서 발생하는 누수문제를 자동으로 찾아주는 기술입니다.</template>
    <template v-slot:copy-sub>
      딥러닝 기술을 활용하여 배관설비 누수의 확률 수치를 제공합니다.
    </template>
  </DemoMast>
  <DemoBody v-if="!result">
    <DemoTitle>
      <template v-slot:title>
        {{meta.uploadTitle}}
      </template>
      <template v-slot:copy>
        {{meta.uploadCopy}}
      </template>
    </DemoTitle>
    <DemoImageUploader
      :error="error"
      v-on:selectSample="openSample"
      v-on:clearError="clearError"
      v-on:load="setLoad"
      v-on:unload="setUnload"
      v-on:imageLoaded="onImageLoaded"
      v-on:error="setError"
    />
  </DemoBody>
  <LeakLensResult
    v-else
    v-on:reset="result = false"
    v-on:setSampleImage="setSampleImage"
    :result="result"
    :imageUrl="imageUrl"
    :sampleImages="sampleImages"
  />
  <SquareLoader v-if="isLoading" />
  <DemoSampleImageSelector
    v-if="isSelectingSample"
    v-on:set="setSampleImage"
    v-on:close="closeSample"
    :images="sampleImages"
  />
</div>

</template>

<script>
import DemoView from '../DemoView'
import LeakLensResult from './LeakLensResult'

export default {
  data() {
    return {
      sampleImages: [
        'leaklens/sample_leaklens_0000_1.png',
        'leaklens/sample_leaklens_0001_2.png',
        'leaklens/sample_leaklens_0002_3.png',
        'leaklens/sample_leaklens_0003_4.png',
        'leaklens/sample_leaklens_0004_5.png',
        'leaklens/sample_leaklens_0005_6.png',
        'leaklens/sample_leaklens_0006_7.png',
        'leaklens/sample_leaklens_0007_8.png',
        'leaklens/sample_leaklens_0008_9.png',
      ],
      tagKey: "landmark_tags"
    }
  },
  methods: {
  },
  extends: DemoView,
  components: {
    LeakLensResult
  }
}
</script>